import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { withTheme } from '@emotion/react';

import { rootUiActions } from 'companion-app-components/flux/root-ui';

import compose from 'utils/compose';
import WhatsNewView from './WhatsNewView';
import styles from './styles';

const mapDispatchToProps = (dispatch) => ({
  removeDialog: () => dispatch(rootUiActions.removeDialog()),
});

export default compose(
  withTheme,
  connect(null, mapDispatchToProps),
)(withStyles(WhatsNewView, styles));
